import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { AuthShell } from "@/components/auth/AuthShell";
import { PasswordFields } from "@/components/auth/PasswordFields";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";

export default function SetPassword() {
  const navigate = useNavigate();
  const { refreshUser } = useAuth();
  const [password, setPassword] = useState("");
  const [pwValid, setPwValid] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!pwValid) {
      toast.error("Please meet all password requirements and confirm your password.");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/set-password", { password });
      await refreshUser();
      toast.success("Password set — your account is secure.");
      navigate("/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not set your password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Set a password" subtitle="Create a password to secure your account before continuing.">
      <form onSubmit={submit} className="space-y-4">
        <PasswordFields
          password={password}
          setPassword={setPassword}
          onValidChange={setPwValid}
          idPrefix="setpw"
          label="Password"
        />
        <Button type="submit" className="w-full" disabled={loading || !pwValid} data-testid="setpw-submit-button">
          {loading ? "Saving…" : "Set password"}
        </Button>
      </form>
    </AuthShell>
  );
}
